import { useEffect, useState } from "react"
import { getStats, resetStats } from "./performanceTracker"

export default function PerformancePage() {
  const [data, setData] = useState<any[]>([])

  useEffect(() => {
    const interval = setInterval(() => {
      setData(getStats())
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="p-4 text-white">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-bold">
          Performance Dashboard
        </h1>

        <button
          onClick={resetStats}
          className="px-3 py-1 rounded bg-red-500/20"
        >
          Reset
        </button>
      </div>

      <table className="w-full text-sm">
        <thead className="text-left text-white/60">
          <tr>
            <th>Component</th>
            <th>Renders</th>
            <th>Total ms</th>
            <th>Avg ms</th>
          </tr>
        </thead>

        <tbody>
          {data.map((item) => (
            <tr key={item.name} className="border-t border-white/10">
              <td className="py-2">{item.name}</td>
              <td>{item.renders}</td>
              <td>{item.totalTime.toFixed(2)}</td>
              <td>{item.avgTime.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}